module.exports = __webpack_public_path__ + "static/media/RESIDENT_PLUS.dd628033.svg";